import React from 'react';

/**
 * CreateOption Component
 * 
 * Option to create a new tag from search value.
 */
const CreateOption = ({
  searchValue,
  isHighlighted,
  onCreate,
  onMouseEnter,
}) => {
  return (
    <div
      className={`tags-picker__create-option ${isHighlighted ? 'tags-picker__create-option--highlighted' : ''}`}
      onClick={onCreate}
      onMouseEnter={onMouseEnter}
    >
      <span className="tags-picker__create-icon">+</span>
      <span className="tags-picker__create-text">
        Create <strong>"{searchValue}"</strong>
      </span>
    </div>
  );
};

export default CreateOption;

